export const initialState = {
	data: {
		generators: [],
	},
	dialogs: {
		deleteConfirm: false,
		addConfirm: false,
		editConfirm: false,
		viewConfirm: false,
		delegatesConfirm: false,
		selectedRecord: null,
	},
	forms: {
		addGeneratorForm: {
			generatedWasteType: "Non-Hazardous Waste",
			wasteType: "Contractor",
			unn: "",
			crNumber: "",
			address: "",
			companyName: "",
			phoneNumber: "",
			isVerified: true,
		},
		editGeneratorForm: {
			generatedWasteType: "Non-Hazardous Waste",
			wasteType: "Contractor",
			unn: "",
			crNumber: "",
			address: "",
			companyName: "",
			phoneNumber: "",
			isVerified: true,
		},
		viewGeneratorForm: {
			generatedWasteType: "",
			wasteType: "",
			unn: "",
			crNumber: "",
			address: "",
			companyName: "",
			phoneNumber: "",
			isVerified: true,
		},
		initialEditGeneratorForm: {
			generatedWasteType: "Non-Hazardous Waste",
			wasteType: "Contractor",
			unn: "",
			crNumber: "",
			address: "",
			companyName: "",
			phoneNumber: "",
			isVerified: true,
		},
	},
	ui: {
		generatedWasteTypeOptions: [
			{ value: "Non-Hazardous Waste", label: "Non-Hazardous Waste" },
			{ value: "Hazardous Waste", label: "Hazardous Waste" },
		],
		companyTypeOptions: [
			{ value: "Contractor", label: "Contractor" },
			{ value: "Engineering company", label: "Engineering company" },
			{ value: "Delegate", label: "Delegate" },
			{ value: "Government", label: "Government" },
			{ value: "Other", label: "Other" },
		],

		addUnnVerifyError: "",
	},
	loading: {
		isLoadingBackdrop: false,
		isBackgroundRefreshing: false,
	},
	table: {
		searchInput: "",
		currentPage: 1,
		recordsPerPage: 10,
	},
};

export function manageGeneratorsReducer(state, action) {
	switch (action.type) {
		case "SET_GENERATORS":
			return {
				...state,
				data: {
					...state.data,
					generators: action.payload || [],
				},
			};
		case "OPEN_DELETE_DIALOG":
			return {
				...state,
				dialogs: {
					...state.dialogs,
					deleteConfirm: true,
					selectedRecord: action.payload,
				},
			};

		case "CLOSE_DELETE_DIALOG":
			return {
				...state,
				dialogs: {
					...state.dialogs,
					deleteConfirm: false,
					selectedRecord: null,
				},
			};

		case "OPEN_EDIT_DIALOG":
			return {
				...state,
				dialogs: {
					...state.dialogs,
					editConfirm: true,
					selectedRecord: action.payload.record,
				},
				forms: {
					...state.forms,
					editGeneratorForm: action.payload.editFormData,
					initialEditGeneratorForm:
						action.payload.initialEditGeneratorForm ?? action.payload.editFormData,
				},
			};

		case "CLOSE_EDIT_DIALOG":
			return {
				...state,
				dialogs: {
					...state.dialogs,
					editConfirm: false,
					selectedRecord: null,
				},
				forms: {
					...state.forms,
					editGeneratorForm: initialState.forms.editGeneratorForm,
					initialEditGeneratorForm: initialState.forms.initialEditGeneratorForm,
				},
			};

		case "OPEN_ADD_DIALOG":
			return {
				...state,
				dialogs: {
					...state.dialogs,
					addConfirm: true,
				},
				ui: {
					...state.ui,
					addUnnVerifyError: "",
				},
			};

		case "CLOSE_ADD_DIALOG":
			return {
				...state,
				forms: {
					...state.forms,
					addGeneratorForm: initialState.forms.addGeneratorForm,
				},
				ui: {
					...state.ui,
					addUnnVerifyError: "",
				},
				dialogs: {
					...state.dialogs,
					addConfirm: false,
				},
			};


		case "OPEN_VIEW_DIALOG":
			return {
				...state,
				dialogs: {
					...state.dialogs,
					viewConfirm: true,
					selectedRecord: action.payload.record,
				},
				forms: {
					...state.forms,
					viewGeneratorForm: action.payload.viewFormData,
				},
			};

		case "CLOSE_VIEW_DIALOG":
			return {
				...state,
				dialogs: {
					...state.dialogs,
					viewConfirm: false,
					selectedRecord: null,
				},
				forms: {
					...state.forms,
					viewGeneratorForm: initialState.forms.viewGeneratorForm,
				},
			};

		case "OPEN_DELEGATES_DIALOG":
			return {
				...state,
				dialogs: {
					...state.dialogs,
					delegatesConfirm: true,
					selectedRecord: action.payload,
				},
			};

		case "CLOSE_DELEGATES_DIALOG":
			return {
				...state,
				dialogs: {
					...state.dialogs,
					delegatesConfirm: false,
					selectedRecord: null,
				},
			};

		case "UPDATE_FORM_FIELD":
			return {
				...state,
				forms: {
					...state.forms,
					[action.payload.formName]: {
						...state.forms[action.payload.formName],
						[action.payload.fieldName]: action.payload.value,
					},
				},
			};

		case "SET_ADD_UNN_VERIFY_ERROR":
			return {
				...state,
				ui: {
					...state.ui,
					addUnnVerifyError: action.payload || "",
				},
			};

		case "SET_LOADING":
			return {
				...state,
				loading: {
					...state.loading,
					[action.payload.key]: action.payload.value,
				},
			};

		case "SET_SEARCH_INPUT":
			return {
				...state,
				table: { ...state.table, searchInput: action.payload, currentPage: 1 },
			};

		case "SET_CURRENT_PAGE":
			return {
				...state,
				table: { ...state.table, currentPage: action.payload },
			};

		default:
			return state;
	}
}
